import './launchpad-embed-reset';
import './lib/surveyjs-license';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AppRoot } from './app/AppRoot';
import { setBaseUrl } from '@eureca/recruiter-api-sdk/client';
import { recruiterEnv } from './config/env';
import { queryClient } from './lib/query-client';
import { router } from './router/router';
import './index.css';

// Point the SDK at the runtime-resolved BFF host (eureca.dev vs eureca.me). The
// SDK otherwise reads the build-time VITE_API_URL, which is wrong when the same
// bundle is served from recrutador.eureca.me. @see config/env.ts
setBaseUrl(recruiterEnv.apiUrl);

const RouterDevtoolsLazy = import.meta.env.DEV
  ? lazy(() => import('./router/router-devtools').then((m) => ({ default: m.RouterDevtools })))
  : () => null;

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <AppRoot pathname={window.location.pathname}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{ query: queryClient }} />

        {import.meta.env.DEV ? (
          <Suspense fallback={null}>
            <RouterDevtoolsLazy />
          </Suspense>
        ) : null}
      </QueryClientProvider>
    </AppRoot>
  </StrictMode>
);
